const state = {
	propertyDialogRoad: {
		isActive: false,
	},
	propertyDialogTrench: {
		isActive: false,
	},
	propertyDialogFlat: {
		isActive: false,
	},
	propertyDialogSolidMesh: {
		isActive: false,
	},
	propertyDialogFoundationExcavation: {
		isActive: false,
	},
};

const getters = {
	isPropertyDialogRoadActive(state) {
		return state.propertyDialogRoad.isActive;
	},
	isPropertyDialogTrenchActive(state) {
		return state.propertyDialogTrench.isActive;
	},
	isPropertyDialogFlatActive(state) {
		return state.propertyDialogFlat.isActive;
	},
	isPropertyDialogSolidMeshActive(state) {
		return state.propertyDialogSolidMesh.isActive;
	},
	isPropertyDialogFoundationExcavationActive(state) {
		return state.propertyDialogFoundationExcavation.isActive;
	},
};

const mutations = {
	showDialog(state, dialogName) {
		state[dialogName].isActive = true;
	},
	closeDialog(state, dialogName) {
		state[dialogName].isActive = false;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
};
